import React from "react";
import { Grid } from "@mui/material";

const DSGrid = (props: React.ComponentProps<typeof Grid>) => {
  return <Grid {...props} />;
};

export default DSGrid;
